import { get, post } from '../utils/request';

/**
 * 获取首页banner
 * @param {*} vm
 * @param {*} cb
 */
export const getBanner = (vm, cb) => {
  post('/api/banner/bannerList')
    .then(res => {
      // console.log(res);
      if (res.code === 200) {
        vm.bannerImg = res.data.map(item => {
          item.imgUrl = item.imgUrl
            ? vm.comImgUrl + item.imgUrl.split('|')[0]
            : '';
          return item;
        });
      }
      cb && cb(res);
      vm.$tips_msg(vm, res);
    })
    .catch(error => {
      vm.$tips_error(vm, error);
    });
};
